import { Alert, Box, Button, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import React from 'react';

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    override render() {
        if (this.state.hasError) {
            return (
                <Box p="xl" maw={600} mx="auto" mt="xl">
                    <Alert icon={<IconAlertTriangle size={20} />} title="Something went wrong" color="red">
                        <Text mb="md">An unexpected error occurred. Please try refreshing the page.</Text>
                        {this.state.error && (
                            <Text size="xs" c="dimmed" mb="md" ff="monospace">
                                {this.state.error.message}
                            </Text>
                        )}
                        <Button variant="outline" color="red" onClick={() => window.location.reload()}>
                            Refresh page
                        </Button>
                    </Alert>
                </Box>
            );
        }

        return this.props.children;
    }
}
